<template>
  <footer>
    <span>
      &copy; {{ currentYear }} | Έκδοση: v{{ version }}
    </span>
  </footer>
</template>

<script>
import { ref, onMounted } from 'vue';

export default {
  name: 'MainFooter',
  setup() {
    const currentYear = new Date().getFullYear();
    const version = ref('loading...');

    // Update version from window.__APP_VERSION__ periodically
   const updateVersion = () => {
      if (window.__APP_VERSION__) {
        const parts = window.__APP_VERSION__.split('_'); // ['0.0.12', '012']
        version.value = parts[0]; // only the build
      }
    };


    onMounted(() => {
      updateVersion(); // initial
      setInterval(updateVersion, 1000); // keep in sync
    });

    return { currentYear, version };
  }
};
</script>

<style scoped>
footer {
  background-color: rgb(34, 121, 179);
  color: #FFFFFF;
  padding: 5px;
  text-align: center;
  bottom: 0;
  width: 100%;
  z-index: 9999;
  font-size: 13px;
  position: fixed;
}
</style>
